import React, { useEffect, useState } from 'react';
import { getPanelDashboard } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { Card, Grid, StatCard, Loading, Badge } from '../../components/UI';

const s = {
  welcome: { fontSize: 24, fontWeight: 700, marginBottom: 6 },
  sub:     { fontSize: 14, color: '#6b6b80', marginBottom: 28 },
  camCard: { background: '#0f0f17', border: '1px solid #1e1e2e', borderRadius: 12, padding: '16px 20px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 16 },
  camName: { fontWeight: 600, fontSize: 15, flex: 1 },
  noData:  { textAlign: 'center', padding: '40px 20px', color: '#6b6b80', fontSize: 14 },
};

const statusColor = { ACTIVE: '#55efc4', PAUSED: '#ffd200', DELETED: '#ff6584' };

export default function ClientDashboard() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const { userProfile }     = useAuth();

  useEffect(() => {
    getPanelDashboard()
      .then(r => setData(r.data?.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  const inv = data?.invoiceSummary || {};

  return (
    <div>
      <div style={s.welcome}>স্বাগতম, {userProfile?.name}! 👋</div>
      <div style={s.sub}>{data?.client?.businessName || 'আপনার business'} — {data?.client?.plan || 'BASIC'} plan</div>

      {!data?.client ? (
        <Card>
          <div style={s.noData}>
            ⏳ আপনার account এখনো campaign এর সাথে connect হয়নি।<br />
            Admin এর সাথে যোগাযোগ করুন।
          </div>
        </Card>
      ) : (
        <>
          {/* Spending Stats */}
          <Grid cols={4}>
            <StatCard label="এই মাসে Spend" value={`৳${parseFloat(data?.spending?.spend || 0).toFixed(0)}`} color="#a29bfe" />
            <StatCard label="Active Campaigns" value={data?.campaigns?.filter(c => c.status === 'ACTIVE').length || 0} color="#55efc4" />
            <StatCard label="মোট Paid" value={`৳${inv.totalPaid?.toLocaleString() || 0}`} color="#43e97b" />
            <StatCard label="Due আছে" value={`৳${inv.totalDue?.toLocaleString() || 0}`} color={inv.totalDue > 0 ? '#ff6584' : '#6b6b80'} />
          </Grid>

          {/* Campaigns */}
          <Card>
            <div style={{ fontWeight: 700, marginBottom: 16, fontSize: 16 }}>📋 আপনার Campaigns</div>
            {data?.campaigns?.length === 0 ? (
              <div style={s.noData}>কোনো campaign নেই</div>
            ) : data?.campaigns?.map((c, i) => (
              <div key={i} style={s.camCard}>
                <div style={{ width: 10, height: 10, borderRadius: '50%', background: statusColor[c.status] || '#6b6b80', flexShrink: 0 }} />
                <div style={s.camName}>{c.name}</div>
                <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 100, background: 'rgba(108,99,255,0.1)', color: '#a29bfe' }}>
                  {c.objective || 'CONVERSIONS'}
                </span>
                <span style={{ fontSize: 13, fontWeight: 600, color: statusColor[c.status] || '#6b6b80' }}>
                  {c.status}
                </span>
              </div>
            ))}
          </Card>

          {/* Invoice Summary */}
          <Card>
            <div style={{ fontWeight: 700, marginBottom: 16, fontSize: 16 }}>🧾 Invoice Summary</div>
            <Grid cols={3}>
              <StatCard label="Total Invoices" value={inv.total || 0} color="#a29bfe" />
              <StatCard label="Paid" value={inv.paid || 0} color="#55efc4" />
              <StatCard label="Pending" value={inv.pending || 0} color="#ffd200" />
            </Grid>
          </Card>
        </>
      )}
    </div>
  );
}
